window.myLocalStorage = {
  getItem(key) {
    // get the parsed value of the given key
    const currentCityPyld = window.localStorage.getItem(key);
    let result = '';

    if (currentCityPyld && /^[\],:{}\s]*$/.test(currentCityPyld.replace(/\\["\\\/bfnrtu]/g, '@').
replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
      result = JSON.parse(currentCityPyld);
    } else {
      window.localStorage.removeItem(key);
    }
      
    // if the key has value
    if(result){ 
        
        // if the entry is expired
        // remove the entry and return null
        if(result.expireTime <= Date.now()){
            window.localStorage.removeItem(key);
            return null;
        }  
        
        // else return the value
        return result.data;
    }
    
    // if the key does not have value
    return null;
  },
  
  // add an entry
  // default expiry is 30 days in milliseconds
  setItem(key, value, maxAge = 30 * 60 * 60 * 1000) {
     // store the value as object
     // along with expiry date
      let result  = {
        data : value
     }
     
     if(maxAge){
       // set the expiry 
       // from the current date
       result.expireTime = Date.now() + maxAge;
     }
     
     // stringify the result
     // and the data in original storage
     window.localStorage.setItem(key, JSON.stringify(result));
  },
  
  // remove the entry with the given key
  removeItem(key) {
    window.localStorage.removeItem(key);
  },
  
  // clear the storage
  clear() {
    window.localStorage.clear();
  }
};

/**
 * NUEVO: Busca, dentro del JSON del producto actual (si existe en la página),
 * la variante cuyo option1/title coincide con el valor de ciudad seleccionado.
 * Retorna el ID de la variante o null si no aplica / no se encuentra.
 */
function getMatchingVariantIdForCity(cityVariantValue) {
  var productJsonElement = document.querySelector('[data-product-json]');

  if (!productJsonElement) {
    return null; // No estamos en una página de producto
  }

  try {
    var parsed = JSON.parse(productJsonElement.innerHTML);
    var productData = parsed.product;

    if (!productData || !productData.variants || !productData.variants.length) {
      return null;
    }

    var matchingVariant = productData.variants.find(function (v) {
      return v.option1 === cityVariantValue || v.title === cityVariantValue;
    });

    if (matchingVariant) {
      return matchingVariant.id;
    } else {
      console.warn('[locations] No se encontró variante para la ciudad "' + cityVariantValue + '" en el producto ' + productData.id + '. Variantes disponibles:', productData.variants.map(function(v){ return v.option1 || v.title; }));
      return null;
    }
  } catch (e) {
    console.error('[locations] Error al parsear el JSON del producto para hacer match de variante', e);
    return null;
  }
}

jQuery("#ciudad").change(function() {
  if (jQuery("#ciudad option[value=selectionKey]").attr('selected', 'selected')) {
    var selectedVariantValue = $("#ciudad").val();

    console.log('|VAL Select cambio a: ', selectedVariantValue);
    console.log('TEXT Select cambio a: ', $( "#ciudad option:selected" ).text());

    myLocalStorage.setItem('ciudadVarianteFinal', selectedVariantValue);
    myLocalStorage.setItem('ciudadCiudadFinal', $( "#ciudad option:selected" ).text());

    // NUEVO: si estamos en una página de producto, calculamos la URL de destino
    // apuntando a la variante correspondiente a la nueva ciudad
    var targetUrl = null;
    var matchingVariantId = getMatchingVariantIdForCity(selectedVariantValue);

    if (matchingVariantId) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', matchingVariantId);
      // NUEVO: rompe cualquier coincidencia con una respuesta ya precargada
      // (Speculation Rules API de Shopify / instant.page), forzando siempre
      // un fetch fresco al servidor en vez de reutilizar una versión en caché
      url.searchParams.set('_r', Date.now());
      targetUrl = url.href;
    }

    clearcart(targetUrl);
  }

});
jQuery(document).ready(function($) {
    if (!myLocalStorage.getItem('ciudadVarianteFinal')) {
      $("#modal--ciudades").attr({
        "aria-hidden": 'false' // Abre el popup
      });
    } else {
      clickCity();
      $("#modal--ciudades").attr({"aria-hidden": 'true'});
      if (!myLocalStorage.getItem('modal--ciudad')) {
        $("#modal--imagen").attr({
          "aria-hidden": 'false' // Abre el popup
        });
      } else {
        $("#modal--imagen").attr({
          "aria-hidden": 'true' // Cierra el popup
        });
      }
      
    }  
  });
  function abrirCoberturas() {
    $("#modal--ciudades").attr({
      "aria-hidden": 'false' // Abre el popup
    });
  }
  function cerrarCoberturas() {
    $("#modal--ciudades").attr({
      "aria-hidden": 'true' // Cierra el popup
    });
    myLocalStorage.setItem('ciudadVarianteFinal', 'Minorista', 1 * 60 * 60 * 1000);
    myLocalStorage.setItem('ciudadCiudadFinal', 'Medellín', 1 * 60 * 60 * 1000);
    clearcart();
  }
  function clickCity() {
    var localizacion = myLocalStorage.getItem('ciudadVarianteFinal');
    var ref_this = $("w3-button").find(localizacion);
    if (ref_this) {
      $('.' + localizacion).trigger('click');
      $('.product-item.w3-button.' + localizacion).css('display', 'block');
      // NUEVO: en la página de Ofertas, oculta los productos que no tengan
      // descuento real en la ciudad activa (aunque estén disponibles ahí).
      filterOfertasByCity(localizacion);
    }
  }

  /**
   * NUEVO: Solo aplica dentro de la colección de Ofertas Campo Azul.
   * Un producto puede estar disponible en varias ciudades, pero el badge
   * de oferta (product-item__city-badge) solo existe para las ciudades
   * donde realmente hay compare_at_price > price. Si el producto no tiene
   * ese badge para la ciudad activa, se oculta de este listado específico
   * (en otras colecciones normales seguirá visible con su precio normal).
   */
  function filterOfertasByCity(cityName) {
    if (window.location.pathname.indexOf('/collections/ofertas-campo-azul') === -1) {
      return;
    }
    $('.product-item.w3-button.' + cityName).each(function () {
      var tieneOfertaEnEstaCiudad = $(this).find('.product-item__city-badge[data-city="' + cityName + '"]').length > 0;
      if (!tieneOfertaEnEstaCiudad) {
        $(this).css('display', 'none');
      }
    });
  }
  /**
   * MODIFICADO: se corrigió el selector "city" -> ".city" (faltaba el punto
   * para funcionar como selector de clase), y se agregó la sincronización
   * del badge de oferta segmentado por ciudad (product-item__city-badge),
   * generado en snippets/product-item.liquid con id="{{ section.id }}{{ variant.id }}oferta".
   */
  function openCity(cityName) {
    var i;
    var target = document.getElementById(cityName);
    if (!target) {
      return;
    }

    // CORREGIDO: antes se ocultaban TODOS los .city de la página completa,
    // sin importar a qué producto pertenecían. En una colección con muchos
    // productos, clickCity() llama a openCity() una vez por producto, y
    // cada llamada borraba lo que la llamada anterior (de OTRO producto)
    // acababa de mostrar, dejando casi todos los precios ocultos al final.
    // Ahora solo se ocultan los .city que son hermanos del elemento
    // objetivo (es decir, del MISMO producto), usando su padre común.
    var scope = target.parentNode;
    var x = scope.querySelectorAll('.city');
    for (i = 0; i < x.length; i++) {
      x[i].style.display = "none";
    }
    target.style.display = "block";

    // NUEVO: sincroniza el badge de oferta con la ciudad activa, con el
    // mismo alcance por producto (buscamos dentro del product-item más
    // cercano en vez de en toda la página).
    var productItemScope = target.closest('.product-item') || document;
    var badges = productItemScope.querySelectorAll('.product-item__city-badge');
    for (i = 0; i < badges.length; i++) {
      badges[i].style.display = "none";
    }
    var badgeEl = document.getElementById(cityName + "oferta");
    if (badgeEl) {
      badgeEl.style.display = "block";
    }
  }
  /**
   * MODIFICADO: ahora acepta un parámetro opcional targetUrl.
   * Si se provee, redirige ahí (con location.replace, para no ensuciar
   * el historial) después de limpiar el carrito.
   * Si no, mantiene el comportamiento original (recargar la misma URL).
   */
  function clearcart(targetUrl) {
  $.ajax({
    type: "POST",
    url: '/cart/clear.js',
    data: '',
    dataType: 'json',
    success: function() {
      Shopify.clear();
    },
    error: function(XMLHttpRequest, textStatus) {}
  });
  setTimeout(function(){
   window.location.replace(targetUrl || window.location.href);
}, 300);
}

if (window.location.pathname === '/') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Suba-Bogota') {
    window.open("https://www.campoazul.co/pages/bogota", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Bucaramanga-Concordia') {
    window.open("https://www.campoazul.co/pages/bucaramanga", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Eje-Cafetero-Pinares') {
    window.open("https://www.campoazul.co/pages/pereira", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}
if (window.location.pathname === '/') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Barranquilla') {
    window.open("https://www.campoazul.co/pages/barranquilla", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bogota') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Bucaramanga-Concordia') {
    window.open("https://www.campoazul.co/pages/bucaramanga", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bogota') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Minorista') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bogota') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Bello') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bogota') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Itaguí') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bogota') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Envigado') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bogota') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Sabaneta') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bogota') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'La Estrella') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bogota') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Rionegro') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bogota') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Eje-Cafetero-Pinares') {
    window.open("https://www.campoazul.co/pages/pereira", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bogota') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Barranquilla') {
    window.open("https://www.campoazul.co/pages/barranquilla", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bucaramanga') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Suba-Bogota') {
    window.open("https://www.campoazul.co/pages/bogota", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bucaramanga') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Minorista') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bucaramanga') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Bello') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bucaramanga') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Itaguí') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bucaramanga') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Envigado') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bucaramanga') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Sabaneta') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bucaramanga') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'La Estrella') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bucaramanga') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Rionegro') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bucaramanga') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Eje-Cafetero-Pinares') {
    window.open("https://www.campoazul.co/pages/pereira", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/bucaramanga') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Barranquilla') {
    window.open("https://www.campoazul.co/pages/barranquilla", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/pereira') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Suba-Bogota') {
    window.open("https://www.campoazul.co/pages/bogota", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/pereira') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Minorista') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/pereira') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Bello') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/pereira') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Itaguí') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/pereira') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Envigado') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/pereira') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Sabaneta') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/pereira') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'La Estrella') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/pereira') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Rionegro') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/pereira') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Bucaramanga-Concordia') {
    window.open("https://www.campoazul.co/pages/bucaramanga", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/pereira') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Barranquilla') {
    window.open("https://www.campoazul.co/pages/barranquilla", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/barranquilla') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Suba-Bogota') {
    window.open("https://www.campoazul.co/pages/bogota", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/barranquilla') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Minorista') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/barranquilla') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Bello') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/barranquilla') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Itaguí') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/barranquilla') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Envigado') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/barranquilla') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Sabaneta') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/barranquilla') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'La Estrella') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/barranquilla') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Rionegro') {
    window.open("https://www.campoazul.co/", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/barranquilla') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Bucaramanga-Concordia') {
    window.open("https://www.campoazul.co/pages/bucaramanga", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

if (window.location.pathname === '/pages/barranquilla') {
  if (myLocalStorage.getItem('ciudadVarianteFinal') === 'Eje-Cafetero-Pinares') {
    window.open("https://www.campoazul.co/pages/pereira", "_parent"); // Open in a new tab/window
  } else {
    // Handle other cases if needed
  }
}

function ordenar(){
setTimeout(function(){ 
 window.location.href = window.location.href;
}, 300);
}


  $('.header__action-item--locale .header__action-item-content .locale-selector__value').text(myLocalStorage.getItem('ciudadCiudadFinal'));
  $('#ciudadtooltip').text(myLocalStorage.getItem('ciudadCiudadFinal'));
  console.log('LocalStorage: ', myLocalStorage.getItem('ciudadVarianteFinal'));
  console.log('LocalStorage Ciudad: ', myLocalStorage.getItem('ciudadCiudadFinal'));